import React from "react";

const OurTeam = () => {
  return (
    <>
      {/* <link rel="stylesheet" href="https://cdn.materialdesignicons.com/6.5.95/css/materialdesignicons.min.css"> */}

      <div class="flex items-center justify-center min-h-screen bg-white py-24">
        <div class="flex flex-col">
          <div class="flex flex-col mt-8">
            <div class="container max-w-7xl px-4">
              <div class="flex flex-wrap justify-center text-center mb-6 md:mb-12">
                <div class="w-full lg:w-6/12 px-4">
                  <h2 class="text-gray-900 text-[28px] md:text-4xl font-bold font-main mb-4 md:mb-12 text-center">
                    Meet Our Team
                  </h2>

                  <p class="text-gray-700 text-[15px] md:text-lg font-light font-outfit">
                    With several years of combined experience, we've got a
                    well-seasoned team at the helm.
                  </p>
                </div>
              </div>

              <div class="flex flex-wrap">
                <div class="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
                  <div class="flex flex-col">
                    <a href="#" class="mx-auto">
                      <img
                        class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                        src="https://source.unsplash.com/WMD64tMfc4k"
                        alt=""
                      />
                    </a>

                    <div class="text-center mt-6">
                      <h1 class="text-gray-900 text-xl font-bold mb-1">
                        Tranter Jaskulski
                      </h1>

                      <div class="text-gray-700 font-light mb-2">
                        Co-Founder / CEO
                      </div>

                      <div
                        class="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300">
                        <a
                          href="#"
                          class="flex rounded-full hover:bg-indigo-50 h-10 w-10">
                          <i class="mdi mdi-linkedin text-indigo-500 mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-blue-50 h-10 w-10">
                          <i class="mdi mdi-twitter text-blue-300 mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-orange-50 h-10 w-10">
                          <i class="mdi mdi-instagram text-orange-400 mx-auto mt-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
                  <div class="flex flex-col">
                    <a href="#" class="mx-auto">
                      <img
                        class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                        src="https://source.unsplash.com/p9Dh4EAhcfg"
                        alt=""
                      />
                    </a>

                    <div class="text-center mt-6">
                      <h1 class="text-gray-900 text-xl font-bold mb-1">
                        Denice Jagna
                      </h1>

                      <div class="text-gray-700 font-light mb-2">
                        Co-Founder / CTO
                      </div>

                      <div
                        class="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300">
                        <a
                          href="#"
                          class="flex rounded-full hover:bg-indigo-50 h-10 w-10">
                          <i class="mdi mdi-linkedin text-orange mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-blue-50 h-10 w-10">
                          <i class="mdi mdi-twitter text-blue-400 mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-orange-50 h-10 w-10">
                          <i class="mdi mdi-instagram text-orange-400 mx-auto mt-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
                  <div class="flex flex-col">
                    <a href="#" class="mx-auto">
                      <img
                        class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                        src="https://source.unsplash.com/0Zx1bDv5BNY"
                        alt=""
                      />
                    </a>

                    <div class="text-center mt-6">
                      <h1 class="text-gray-900 text-xl font-bold mb-1">
                        Kenji Milton
                      </h1>

                      <div class="text-gray-700 font-light mb-2">
                        Business Relations
                      </div>

                      <div
                        class="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300">
                        <a
                          href="#"
                          class="flex rounded-full hover:bg-indigo-50 h-10 w-10">
                          <i class="mdi mdi-linkedin text-orange mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-blue-50 h-10 w-10">
                          <i class="mdi mdi-twitter text-blue-400 mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-orange-50 h-10 w-10">
                          <i class="mdi mdi-instagram text-orange-400 mx-auto mt-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-4">
                  <div class="flex flex-col">
                    <a href="#" class="mx-auto">
                      <img
                        class="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                        src="https://source.unsplash.com/_5_CBVCLBsY"
                        alt=""
                      />
                    </a>

                    <div class="text-center mt-6">
                      <h1 class="text-gray-900 text-xl font-bold mb-1">
                        Diana Ruswell
                      </h1>

                      <div class="text-gray-700 font-light mb-2">
                        Director of Product
                      </div>

                      <div
                        class="flex items-center justify-center opacity-50 hover:opacity-100
                                transition-opacity duration-300">
                        <a
                          href="#"
                          class="flex rounded-full hover:bg-indigo-50 h-10 w-10">
                          <i class="mdi mdi-linkedin text-orange mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-blue-50 h-10 w-10">
                          <i class="mdi mdi-twitter text-blue-400 mx-auto mt-2"></i>
                        </a>

                        <a
                          href="#"
                          class="flex rounded-full hover:bg-orange-50 h-10 w-10">
                          <i class="mdi mdi-instagram text-orange-400 mx-auto mt-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurTeam;
